import {useFluxStore} from 'client/framework';
import classnames from 'classnames';
import type {ReactNode} from 'react';
import React from 'react';
import {Icon} from '@albert-io/atomic';

import appStore from 'client/AppStore';

import './correctness-indicator-wapper.scss';

interface CorrectnessIndicatorWrapperProps {
  isGuessSubmitted?: boolean;
  isCorrectAnswer?: boolean;
  isSelected?: boolean;
  iconOnly?: boolean;
  className?: string;
  size?: number;
  as?: React.ElementType;
  children?: ReactNode;
  [key: string]: any;
}

export default function CorrectnessIndicatorWrapper({
  isGuessSubmitted = false,
  isCorrectAnswer,
  isSelected,
  iconOnly,
  className,
  size = 28,
  as: Wrapper = 'div',
  children,
  ...passthroughProps
}: CorrectnessIndicatorWrapperProps) {
  const isMobileView = useFluxStore(appStore, (s) => s.isMobileView());
  const getOffset = () => {
    return isMobileView ? 10 : 20;
  };

  const getIndicatorStyles = () => {
    const sizeString = `${size}px`;
    const styles: any = {
      height: sizeString,
      width: sizeString,
      fontSize: `${0.6 * size}px`
    };
    if (children) {
      styles.right = `${getOffset()}px`;
    }
    return styles;
  };

  const getWrapperStyles = () => {
    if (!children || !isGuessSubmitted) {
      return null;
    }
    return {
      paddingRight: `${getOffset() + size}px`
    };
  };

  const generateIndicator = () => {
    if (!isGuessSubmitted || (!isSelected && !isCorrectAnswer)) {
      return null;
    }
    return (
      <Icon
        iconStyle='regular'
        icon={isCorrectAnswer ? 'circle-check' : 'circle-xmark'}
        color={isCorrectAnswer ? 'positive' : 'negative'}
        className={classnames('correctness-indicator-wrapper__indicator !text-xxl', {
          'correctness-indicator-wrapper__indicator--icon-only': iconOnly
        })}
        style={getIndicatorStyles()}
      />
    );
  };

  return (
    <Wrapper
      {...passthroughProps}
      className={classnames('correctness-indicator-wrapper', className, {
        'correctness-indicator-wrapper--with-children': children
      })}
      style={getWrapperStyles()}
    >
      {children}
      {generateIndicator()}
    </Wrapper>
  );
}
